export const ErrorCode = {
    'BadRequest': 40000,
    'OldPasswordIncorrect': 40001,
    'SigniRequestFailed': 40002,
    'Unauthorized': 40100,
    'Forbidden': 40300,
    'EmailNotVerified': 40301,
    'NotFound': 40400,
    'UserNotFound': 40401,
    'TemplateNotFound': 40402,
    'Conflict': 40900,
    'UserAlreadyExists': 40901,
    'CompanyAlreadyExists': 40902,
    'EmailAlreadyExists': 40903,
    'CannotBlockSelf': 40904,
    'CannotBlockAdmin': 40905,
    'InvalidRole': 40906,
    'CannotChangeOwnRole': 40907,
    'UserAlreadyInAccount': 40908,
    'CannotRemoveSelf': 40909,
    'CannotRemoveLastOwner': 40910,
    'CannotRemoveOwner': 40911,
    'CannotDowngradeOwner': 40912,
    'CannotDowngradeLastOwner': 40913,
    'PricingRatesSupplierAccountsOnly': 40302,
    'LlmChatSessionAlreadyCompleted': 40303,
    'PlanLimitExceeded': 40304,
    'InvalidPricingRates': 40003,
    'LlmChatSessionNoMessages': 40004,
    'LinkedinOnlySignInMethod': 40005,
    'LinkedinNoVerifiedEmail': 40006,
    'LinkedinAuthFailed': 40007,
    'GoogleOnlySignInMethod': 40009,
    'GoogleNoVerifiedEmail': 40010,
    'GoogleAuthFailed': 40011,
    'SsoOnlySignInMethod': 40012,
    'InquirerCompanyProfileNotReady': 40008,
    'LlmChatSessionModelLocked': 40914,
    'LinkedinAlreadyLinked': 40915,
    'GoogleAlreadyLinked': 40918,
    'DecisionVersionConflict': 40916,
    'DecisionConditionallyReady': 40917,
    'DecisionSecondPersonRequired': 40305,
    'DecisionForbiddenAction': 40306,
    'DecisionAgentDisabled': 40307,
    'DecisionEvidenceExitBar': 42200,
    'DecisionUnsupportedClaim': 42201,
    'DecisionHardConstraintFailed': 42202,
    'AgentConfigDraftCannotBeDefault': 42203,
    'AgentConfigInactiveCannotBeDefault': 42204,
    'AgentConfigInquiryRequiredCannotBeDefault': 42205,
    'LinkedinPendingSignupExpired': 40101,
    'GooglePendingSignupExpired': 40102,
    'Gone': 41000,
    'TooManyRequests': 42900,
    'InternalServerError': 50000,
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];

/** RFC 7807 Problem Details (API error response body). */
export interface ProblemDetails {
    type: string;
    title: string;
    status: number;
    code: ErrorCode;
    detail?: string;
    instance?: string;
    /** Stable machine key for client-side translation of validation / decision errors. */
    reason?: string;
    /** Evidence-exit or gate fields that the client must complete. */
    missingItems?: string[];
    /** Field-level issues for client-side translation (e.g. company profile readiness). */
    issues?: Array<{ field?: string; code?: string }>;
}
